import { Amplify } from "aws-amplify";

export const configureAmplify = (): void => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
        loginWith: {
          email: true,
          oauth: {
            domain: import.meta.env.VITE_COGNITO_DOMAIN,
            redirectSignIn: [import.meta.env.VITE_APP_URL],
            redirectSignOut: [import.meta.env.VITE_APP_URL],
            responseType: "code" as const,
            scopes: ["openid", "email", "profile"],
          },
        },
      },
    },
    API: {
      Events: {
        // HTTP endpoint + "/event" path. Amplify derives the WebSocket URL from it.
        endpoint: import.meta.env.VITE_APPSYNC_EVENTS_URL,
        region: import.meta.env.VITE_AWS_REGION,
        defaultAuthMode: "userPool",
      },
    },
  });
};
